export const generarCadenaAleatoria = (longitud: number = 4): string =>
	Array.from({ length: longitud }, () => "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"[Math.floor(Math.random() * 62)]).join("");

export const convertTakenAtToSystemTime = (takenAt: number) => {
	if (!takenAt) return null;
	const date = new Date(takenAt * 1000);
	return date.toLocaleString();
};

export const timeAgo = (takenAt: number) => {
	const now = Math.floor(Date.now() / 1000);
	const differenceInSeconds = now - takenAt;
	if (differenceInSeconds < 0) return "Fecha en el futuro";
	const hours = Math.floor(differenceInSeconds / 3600);
	const minutes = Math.floor((differenceInSeconds % 3600) / 60);
	let result = "hace ";
	if (hours > 0) result += `${hours} hora${hours > 1 ? "s" : ""}`;
	if (hours > 0 && minutes > 0) result += " y ";
	if (minutes > 0) result += `${minutes} minuto${minutes > 1 ? "s" : ""}`;
	if (hours === 0 && minutes === 0) result = "hace menos de un minuto";
	return result;
};

export const shuffleArray = (array: any[]) => {
	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]];
	}
};

export const handleLottery = (listParticipant: string[], listPrizes: string[], setResult: React.Dispatch<React.SetStateAction<{ participants: string[]; prize: string[] }[]>>, isOnly?: boolean) => {
	setResult([]);
	if (listParticipant.length === 0 || listPrizes.length === 0) return;
	let participantsCopy = [...listParticipant];
	let prizesCopy = [...listPrizes];
	shuffleArray(participantsCopy);
	shuffleArray(prizesCopy);
	const finalResult: { participants: string[]; prize: string[] }[] = [];
	if (isOnly) {
		if (prizesCopy.length >= participantsCopy.length) {
			participantsCopy.forEach((participant, index) => {
				const prize = prizesCopy[index];
				finalResult.push({ participants: [participant], prize: [prize] });
			});
		} else {
			participantsCopy.forEach((participant, index) => {
				if (index < prizesCopy.length) {
					const prize = prizesCopy[index];
					finalResult.push({ participants: [participant], prize: [prize] });
				}
			});
		}
		setResult(finalResult);
		return;
	}
	if (prizesCopy.length > participantsCopy.length) {
		const prizesPerParticipant = Math.floor(prizesCopy.length / participantsCopy.length);
		const remainingPrizes = prizesCopy.length % participantsCopy.length;
		participantsCopy.forEach((participant, index) => {
			const assignedPrizes = prizesCopy.splice(0, prizesPerParticipant);
			if (remainingPrizes > 0 && index < remainingPrizes) {
				assignedPrizes.push(prizesCopy.shift()!);
			}
			finalResult.push({ participants: [participant], prize: assignedPrizes });
		});
	} else if (participantsCopy.length > prizesCopy.length) {
		participantsCopy.forEach((participant, index) => {
			const assignedPrize = prizesCopy[index % prizesCopy.length];
			const prizeObj = finalResult.find((result) => result.prize.includes(assignedPrize));
			if (prizeObj) {
				prizeObj.participants.push(participant);
			} else {
				finalResult.push({ participants: [participant], prize: [assignedPrize] });
			}
		});
	} else {
		if (prizesCopy.length >= participantsCopy.length) {
			participantsCopy.forEach((participant, index) => {
				const prize = prizesCopy[index];
				finalResult.push({ participants: [participant], prize: [prize] });
			});
		} else {
			participantsCopy.forEach((participant, index) => {
				if (index < prizesCopy.length) {
					const prize = prizesCopy[index];
					finalResult.push({ participants: [participant], prize: [prize] });
				}
			});
		}
	}
	setResult(finalResult);
};

export const urlBackend = "https://olly-suerte.vercel.app/";
